module.exports = __webpack_public_path__ + "static/media/crypt-default.5ad07abb.jpeg";